import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import { interfaces } from '../constants/storage';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '../styles/storage.module.scss';
import Image from 'next/image';

export default function Storage () {
  const router = useRouter();
  const { t } = useTranslation('storage');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />

      <InfoSection title='Storage' description='storageDescription' getAccessLink='/#try-cloud-section' documentationLink='https://help.icdc.io/storage/' lang={router.locale} />

      <section className={styles.reliable}>
        <div>
          <h2 dangerouslySetInnerHTML={{__html: t('storage_power.title', { interpolation: { escapeValue: false }})}} />
          <p>{t('storage_power.description')}</p>
        </div>
        <Image src={t('storage_power.img')} alt="Storage service" loading='lazy' width={841} height={291} unoptimized />
      </section>

      <section className={styles.interfaces}>
        <h2>{t('interfaces.title')}</h2>
        <div className={'flex ' + styles.interfaces__items}>
          {
            interfaces.map((interfaceItem, index) => <div key={index} className='flex col'>
              <Image src={interfaceItem.img} alt="" loading='lazy' />
              <p>{t(interfaceItem.value)}</p>
            </div>)
          }
        </div>
      </section>

      <section className={styles.s3}>
        <div className={styles.top}>
          <div>
            <h2>{t('supports.title')}</h2>
            <p>{t('supports.description')}</p>
            <a href={"https://docs.icdc.io/" + router.locale + "/outrun-cloud/billable_metrics"} target='_blank'>
              <button className='btn cloud'>{t('learn_more')}</button>
              <span className='sr-only'>{t('learn_more_about_supported_hardware')}</span>
            </a>
          </div>
          <Image src="/storage_supports.webp" alt="" loading='lazy' width={841} height={465} unoptimized />
        </div>

        <div className={styles.middle}>
          <h2>{t('important.title')}</h2>
          <p>{t('important.description')}</p>
          <h3>{t('important.moment.title')}</h3>
          <p dangerouslySetInnerHTML={{__html: t('important.moment.description', { interpolation: { escapeValue: false }})}} />
        </div>

        <div className={'flex ' + styles.bottom}>
          <div>
            <h3>{t('key_benefits')}</h3>
            <p dangerouslySetInnerHTML={{__html: t('important.scalable_description', { interpolation: { escapeValue: false }})}} />
          </div>
          <div>
            <h3>{t('reliable.title')}</h3>
            <p dangerouslySetInnerHTML={{__html: t('reliable.description', { interpolation: { escapeValue: false }})}} />
          </div>
        </div>
      </section>

      <section className={styles.block}>
        <div>
          <h2>{t('block_storage.title')}</h2>
          <p>{t('block_storage.description')}</p>
          <h3>{t('key_benefits')}</h3>
          <p dangerouslySetInnerHTML={{__html: t('block_storage.key_benefits', { interpolation: { escapeValue: false }})}} />
        </div>
      </section>

      <div className={styles.file}>
        <div>
          <h2>{t('file_system.title')}</h2>
          <p>{t('file_system.description')}</p>
        </div>
        <div className={styles.benefits}>
          <h3>{t('key_benefits')}</h3>
          <p dangerouslySetInnerHTML={{__html: t('file_system.key_benefits', { interpolation: { escapeValue: false }})}} />
        </div>
      </div>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['storage', 'common']),
  },
});
